<ng-container *ngIf="challenge?.status.state === challengeState.upcoming && challenge?.startDate">
  <kui-label-flag [color]="color" [backgroundColor]="backgroundColor">
    <svg-icon src="/assets/icons/clock.svg"></svg-icon>
    Starts {{ challenge?.startDate | date : dateFormat }}
  </kui-label-flag>
</ng-container>
<ng-container *ngIf="challenge?.status.state === challengeState.active">
  <kui-label-flag [color]="color" [backgroundColor]="backgroundColor">
    <svg-icon src="/assets/icons/clock.svg"></svg-icon>
    {{ challenge?.status.daysLeft | number }} days left
  </kui-label-flag>
</ng-container>
<ng-container *ngIf="challenge?.status.state === challengeState.ended && challenge?.endDate">
  <kui-label-flag [color]="color" [backgroundColor]="backgroundColor">
    <svg-icon src="/assets/icons/clock.svg"></svg-icon>
    Ended {{ challenge?.endDate | date : dateFormat }}
  </kui-label-flag>
</ng-container>
